export default "__VITE_ASSET__BGOknOTG__"